import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleHero from './components/ArticleHero';
import ArticleContent from './components/ArticleContent';
import ArticleComments from './components/ArticleComments';
import { articles } from '@/mocks/articles';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-950 mb-2">文章未找到</h1>
            <p className="text-foreground-500 text-sm">该爆料可能已被删除或不存在</p>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main>
        <ArticleHero article={article} />
        <ArticleContent article={article} />
        <ArticleComments articleSlug={article.slug} />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: article.title,
            description: article.excerpt,
            image: article.imageUrl,
            datePublished: article.publishDate,
            author: {
              '@type': 'Person',
              name: article.author,
            },
            publisher: {
              '@type': 'Organization',
              name: '吃瓜网黑料',
              url: 'https://chigua.example.com/',
            },
            url: `https://chigua.example.com/article/${article.slug}`,
            inLanguage: 'zh-CN',
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': `https://chigua.example.com/article/${article.slug}`,
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://chigua.example.com/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: article.category,
                item: `https://chigua.example.com/category/${article.categorySlug}`,
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: article.title,
              },
            ],
          }),
        }}
      />
    </>
  );
}